import { formatMoneyWholeAware } from 'lib/utils/format-money';

export const buildPdsPriceString = (
  productPrice?: string | null,
  currencyCode: string = 'USD',
): string | undefined => {
  if (productPrice) {
    return `${formatMoneyWholeAware(productPrice, currencyCode)} / month`;
  }
};
